// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-anchor[data-v-4ad468b0]{padding-top:25px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
